import { isPlatformBrowser } from '@angular/common'

function playPauseVideo(that: any) {
  if (that.isPlaying === false) {
    that.playImg = 'https://cdn.icreditworks.com/tp/assets/images/pause.png'
    that.player.play()
    that.isPlaying = true

  } else {
    that.player.pause()
    that.playImg = 'https://cdn.icreditworks.com/tp/assets/images/play.png'
    that.isPlaying = false
  }
}

function setTime(that: any, e: any) {
  if (!isPlatformBrowser(this.platformId)) {
    return;
  }
  const present: any = e.offsetX / document.querySelector('.videoPlayer__controls_timeline').clientWidth * 100
  that.player.currentTime = ((that.player.duration * present.toFixed(0)) / 100).toFixed(0)
}

function produceCurrentTime(that: any, bar: any) {
  if (that.player.currentTime) {

    that.currentTime = that.player.currentTime
    that.duration = String(that.player.duration - that.player.currentTime)

    const position = that.player.currentTime / that.player.duration
    bar.style.width = position * 100 + '%'
  }
}

export default {
  playPauseVideo,
  setTime,
  produceCurrentTime,

}
